// extracted by mini-css-extract-plugin
module.exports = {"buttonUpload":"style_buttonUpload__304Cv"};